<template>
  <div class="px-3 py-2">
    <a href="https://www.apptek.com"><img v-if="sidebarvis" src="https://apptek-website-assets.s3.amazonaws.com/images/apptek-logo-white-medium.png" width="200" border="0"/></a>
    <p class="mt-2 mb-1 category" style="color:#bbb">PROFILE </p>

    <b-nav vertical pills id="sidelinks" class="mt-0">
      <b-nav-item
        v-for="link in links1"
        :key="link.icon"
        :to="link.path"
        exact
        exact-active-class="active"
        ><b-icon :icon="link.icon" shift-h="-6"></b-icon>
        {{ link.label }}
        </b-nav-item
      >
    </b-nav>

    <p class="mt-4 mb-1 category" style="color:#bbb">PLATFORM</p>

    <b-nav vertical pills id="sidelinks" class="mt-0" fill>
      <b-nav-item
        v-for="link in links2"
        :key="link.icon"
        :href="(link.external === true) ? link.href : null"
        :to="(link.external === true) ? null : link.path"
        :target="(link.external === true) ? '_blank' : '_self'"
        active-class="active"
        :active="activeLink(link.path)">
        <b-icon :icon="link.icon" shift-h="-6"></b-icon>
        {{ link.label }}
        <b-icon icon="box-arrow-up-right" v-if="link.external"></b-icon>
        </b-nav-item
      >
    </b-nav>
  </div>
</template>

<script>
import Vue from 'vue'
import router from 'vue-router'
Vue.use(router)

export default {
  data () {
    return {
      // sidebarvis: true,
      hoveredItem: 0,
      expanded: 0,
      links1: [
        {
          icon: 'person',
          path: '/profile',
          label: 'Edit profile',
          external: false
        },
        // {
        //   icon: 'shield-lock-fill',
        //   path: '/profile',
        //   label: 'Change password',
        //   external: false
        // },
        {
          icon: 'credit-card',
          path: '/billing',
          label: 'Payment method',
          external: false
        },
        {
          icon: 'bag',
          path: '/pricing',
          label: 'Price plans',
          external: false
        }
      ],
      links2: [
        {
          icon: 'box', // gear-fill, intersect, subtract
          path: '/apps',
          label: 'Apps & API Keys',
          external: false
        },
        {
          icon: 'arrow-left-right',
          path: '/translate/docs',
          label: 'Translate',
          external: false
        },
        {
          icon: 'soundwave',
          path: '/transcribe',
          label: 'Transcribe',
          external: false
        },
        {
          icon: 'file-earmark-text',
          path: '/lexicons',
          label: 'Transcribe lexicons',
          external: false
        },
        {
          icon: 'graph-up',
          path: '/usage',
          label: 'Usage',
          external: false
        },
        // {
        //   icon: 'clock',
        //   path: '/status',
        //   label: 'System status',
        //   external: false
        // },
        {
          icon: 'book',
          path: '/docs',
          label: 'Documentation',
          external: true,
          href: 'https://docs.apptek.com'
        },
        {
          icon: 'chat-dots',
          path: '/support',
          label: 'Support Request',
          external: true,
          href: 'https://support.apptek.com'
        },
        {
          icon: 'power',
          path: '/logout',
          label: 'Logout',
          external: false
        }
      ]
    }
  },
  computed: {
    sidebarvis () {
      return this.$store.state.sidebarvis
    }
  },
  methods: {
    openExternal (path) {
      const routeData = this.$router.resolve({ path: path, query: {} }) // , query: {data: "someData"}});
      window.open(routeData.href, '_blank')
    },
    activeLink (s) {
      return this.$route.path.substring(s) === 0
    }
  }
}
</script>

<style scoped>
/** Sidebar links */
a.nav-link {
  color: white !important;
  font-size: 0.97em;
}

/* .nav-pills .nav-link.active { */
.nav-pills .nav-link.active, .nav-pills .show > .nav-link,
.router-link-exact-active {
  background-color: white;
  color: #000 !important;
}

.category {
  color: #fff
}
</style>
